<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	<lgb-back></lgb-back>
	<h1 class="element-show my-4 text-center" [style.--i]="0">
		<span class="brand">Legend</span>
		<i class="text-primary fa-regular fa-plus"></i>
	</h1>
	<p class="text-center opacity-60 mb-4">
		Passe au niveau légendaire
	</p>

	<fieldset class="element-show mb-4 text-base fieldset border-base-300 rounded-box border p-4 glass" [style.--i]="1">
		<h2>Legend <i class="text-primary fa-regular fa-plus"></i></h2>
		<p class="price mt-2 pb-2 text-xl font-bold">
			2,50€
			<span class="text-base font-normal text-base-content/60">/ mois</span> 
		</p>

		<!-- methods -->
		<lgb-payment-method 
			[amount]="29.9"
			[order$]="orderS.createPlanOrder()"
			[(payLoading)]="loading"
			(error)="router.navigate('payment-failed')"
		></lgb-payment-method>

		<span class="my-1 ml-1 text-center text-xs opacity-60">
			En validant, vous acceptez les 
			<a href="#" [routerLink]="router.get('cgv')" class="text-primary">conditions générales</a>
			et la facturation annnuelle
		</span>
	</fieldset>
</div>